// FIXME: rename file?
import { useQueries, UseQueryOptions } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IExtraction } from '../../types/my-types';
import { getIdFromUrl } from '../../utils/getIdFromUrl';
import { IResultsType } from '../../types/spreadsheet-types';
import getExtractionRange from '../../utils/getExtractionRange';

export function useExtractionSpreadsheet(extractions: IExtraction[], resultsType: IResultsType) {
  const glynt = useGlynt();

  const buildQuery = extractions.map((extraction: IExtraction) => {
    const extractionId = getIdFromUrl(extraction);

    if (resultsType === 'corrected') {
      return {
        queryKey: ['extraction', extractionId, { view: 'corrected' }],
        queryFn: async () => (await glynt).extraction.retrieve_corrected_results(extractionId),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
      };
    } else {
      return {
        queryKey: ['extraction', extractionId, { view: 'normalized' }],
        queryFn: async () => (await glynt).extraction.retrieve_normalized_results(extractionId),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
      };
    }
  });

  return useQueries({
    queries: buildQuery
  });
}
